import React from 'react';
import { CookiesProvider } from 'react-cookie';

export const withMyFoodList = function(WrappedComponent) {
  const Wrapper = props =>
    <CookiesProvider>
      <WrappedComponent {...props} />
    </CookiesProvider>;
  return Wrapper;
};